// extracted by mini-css-extract-plugin
module.exports = {"form":"form_form__oKlKm","label":"form_label__14Gtg","warning":"form_warning__3uZre"};